module.exports = __webpack_public_path__ + "static/media/refundAmount.6bd58bf6.svg";